import { render, staticRenderFns } from "./SubmitForApprovalDialog.vue?vue&type=template&id=0c26349e&"
import script from "./SubmitForApprovalDialog.vue?vue&type=script&lang=js&"
export * from "./SubmitForApprovalDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports